import { apiClient } from "../apiClient";

export const XEP_LOAI_CHUNG_CHI_ENDPOINT = "xep-loai-chung-chi";
export const xepLoaiChungChiApi = {
    SelectAll: () => apiClient.get(`${XEP_LOAI_CHUNG_CHI_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(`${XEP_LOAI_CHUNG_CHI_ENDPOINT}`, payload),
    Update: (id: number, payload: any) => apiClient.put(`${XEP_LOAI_CHUNG_CHI_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${XEP_LOAI_CHUNG_CHI_ENDPOINT}/${id}`)
};